export function Loading({ label = "Cargando…" }: { label?: string }) {
  return (
    <main className="center-page" id="main">
      <div className="loader" aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
      <p>{label}</p>
    </main>
  );
}

export function ErrorCard({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="error-card" role="alert">
      <span aria-hidden="true">!</span>
      <div>
        <strong>Algo no salió como esperábamos</strong>
        <p>{message}</p>
      </div>
      {onRetry && (
        <button className="hw-btn hw-btn--secondary" onClick={onRetry} type="button">
          Reintentar
        </button>
      )}
    </div>
  );
}

